export enum DataInsightType {
  AnomalousCost = 'Anomalous Cost',
  AnomalousCostPerUnit = 'Anomalous Cost per Unit',
  AnomalousUsage = 'Anomalous Usage',
  ChargesOnlyMeterWithUsageLineItems = 'Charges Only Meter with Usage Line Items',
  DateRecency = 'Data Recency',
  DuplicateBudgetPeriods = 'Duplicate Budget Periods',
  LineItemDateOverlap = 'Line Item Date Overlap',
  LineItemGap = 'Line Item Gap',
  MeterUsageIncreasingOverTime = 'Meter Usage Increasing Over Time',
  MissingBudgetPeriod = 'Missing Budget Period',
  NoUsageLineItem = 'No Usage Line Items',
  UsageAfterInactiveDate = 'Usage After Inactive Date',
  UsageAfterCurrentDate = 'Usage After Current Date',
}
